import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'card' | 'list';
}

export default function ArticleCard({ article, variant = 'card' }: ArticleCardProps) {
  if (variant === 'list') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group flex gap-4 p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
      >
        <div className="w-40 h-28 flex-shrink-0 rounded-lg overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-foreground-500 text-xs line-clamp-2 mb-3">{article.summary}</p>
          <div className="flex items-center gap-3 text-foreground-400 text-xs">
            <span className="inline-flex items-center gap-1">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
            <span>{article.date}</span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.views.toLocaleString()}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg mb-3 aspect-[16/10]">
        <img
          src={article.image}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </div>
      <h3 className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
        {article.title}
      </h3>
      <p className="text-foreground-500 text-xs line-clamp-2 mb-2">{article.summary}</p>
      <div className="flex items-center gap-3 text-foreground-400 text-xs">
        <span>{article.date}</span>
        <span className="inline-flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {article.views.toLocaleString()}
        </span>
      </div>
    </Link>
  );
}